<template>
  <chart-overwrite-modal-base
    v-if="dailyBaseRateOverwriteMetadata.dailyBaseRate"
    ref="baseModal"
    :form-data="dailyBaseRateOverwriteMetadata"
    :modal-id="dailyBaseRateOverwriteMetadata.dailyBaseRate.date"
    :edit-date="dailyBaseRateOverwriteMetadata.dailyBaseRate.date"
    :show-reset-btn="
      dailyBaseRateOverwriteMetadata.dailyBaseRate.isOverwritten()
    "
    :reset-value="
      $options.filters
        .centimesToFr(
          dailyBaseRateOverwriteMetadata.dailyBaseRate.dailyBaseRate
        )
        .toString()
    "
    :submittable="
      newDailyBaseRate !==
      dailyBaseRateOverwriteMetadata.dailyBaseRate.currentBaseRate()
    "
    @overwrite="overwrite"
    @reset="reset"
  >
    <template #title>
      {{ title }}
    </template>

    <!-- <template
        v-slot:help
    >
      <v-row>
        <v-col cols="12">
          <h3>{{$t('dailyBaseRateOverwriteModal.basicPriceOverview')}}</h3>
        </v-col>
        <v-col cols="8" class="caption white-opacity-text">
          {{$t('dailyBaseRateOverwriteModal.workload')}}
        </v-col>
        <v-col cols="4" class="caption white-opacity-text">
          XX%
        </v-col>
      </v-row>
    </template> -->

    <template #body>
      <v-row class="no-gutters font-weight-light">
        <v-col cols="12" class="mb-4">
          {{ $t('dailyBaseRateOverwriteModal.notOkWithDailyBR') }}
        </v-col>
        <v-col cols="8" class="border-bottom-gray">
          {{ $t('dailyBaseRateOverwriteModal.dailyBaseRate') }}
        </v-col>
        <v-col cols="4" class="border-bottom-gray">
          {{
            dailyBaseRateOverwriteMetadata.dailyBaseRate.currentBaseRate()
              | currency
          }}
          <!-- <i
              class="ml-4 fas fa-question clickable"
              @mouseover="openHelpTooltip"
              @mouseleave="openHelpTooltip(false)"
          >
          </i> -->
        </v-col>

        <v-col cols="8" class="border-bottom-primary">
          {{ $t('dailyBaseRateOverwriteModal.change') }}
        </v-col>
        <v-col cols="4" class="border-bottom-primary">
          {{
            (newDailyBaseRate -
              dailyBaseRateOverwriteMetadata.dailyBaseRate.currentBaseRate())
              | currency
          }}
        </v-col>

        <v-col cols="8" class="border-bottom-primary">
          {{ $t('dailyBaseRateOverwriteModal.newDailyBaseRate') }}
        </v-col>
        <v-col cols="4" class="border-bottom-primary">
          {{ newDailyBaseRate | currency }}
        </v-col>
      </v-row>
      <override-slider
        :sliderValue="newDailyBaseRate"
        :sliderStepSize="sliderStepSize"
        :decimals="2"
        :power="2"
        :minValue="
          dailyBaseRateOverwriteMetadata.dailyBaseRate.minDailyBaseRate
        "
        :maxValue="
          dailyBaseRateOverwriteMetadata.dailyBaseRate.maxDailyBaseRate
        "
        :currency="$store.getters.getCurrentDestinationInstance().getCurrency()"
        :minTitle="$t('dailyBaseRateOverwriteModal.min')"
        :maxTitle="$t('dailyBaseRateOverwriteModal.max')"
        @updateSliderValue="newDailyBaseRate = $event"
      ></override-slider>
    </template>
  </chart-overwrite-modal-base>
</template>

<script>
import Vue from 'vue'
import ChartOverwriteModalBase from '@/components-internal/charts/ChartOverwriteModalBase'
import DailyBaseRateService from '@/classes-internal/dailyBaseRate/DailyBaseRateService'
import OverwriteModalMixin from '@/components-internal/mixins/OverwriteModalMixin'
import OverrideSlider from './OverrideSlider'
import _ from 'lodash'

export default Vue.extend({
  name: 'DailyBaseRateOverwriteModal',

  components: { ChartOverwriteModalBase, OverrideSlider },

  mixins: [OverwriteModalMixin],

  props: {
    dailyBaseRateOverwriteMetadata: {
      required: false,
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      newDailyBaseRate: null,
      service: new DailyBaseRateService(),
      sliderStepSize: 1,
    }
  },

  computed: {
    title() {
      return (
        this.$i18n.t('dailyBaseRateOverwriteModal.title') +
        ' ' +
        this.$options.filters.formatDate(
          this.dailyBaseRateOverwriteMetadata.dailyBaseRate.date
        )
      )
    },
  },
  watch: {
    dailyBaseRateOverwriteMetadata: {
      handler: function (newVal) {
        if (newVal.dailyBaseRate) {
          this.newDailyBaseRate = newVal.dailyBaseRate.currentBaseRate()
        }
      },
      deep: true,
    },
  },

  methods: {
    open() {
      this.$refs.baseModal?.openModal()
    },

    async overwrite() {
      await this.service.overwrite(
        this.dailyBaseRateOverwriteMetadata.dailyBaseRate,
        this.newDailyBaseRate
      )
      this.showModal = false
      this.$emit('updated')
    },
    async reset() {
      await this.service.reset(
        this.dailyBaseRateOverwriteMetadata.dailyBaseRate
      )
      this.showModal = false
      this.$emit('updated')
    },
  },
})
</script>
<style scoped>
.priceContainer {
  width: 100%;
}

.price-text-field {
  max-width: 120px;
}
</style>
